// extracted by mini-css-extract-plugin
export default {"isLoading":"hXAs9"};